import { ReactNode } from "react";
import { useTokenRestriction } from "@/hooks/useTokenRestriction";
import { FeatureInDevelopment } from "@/components/ui/feature-in-development";
import { Skeleton } from "@/components/ui/skeleton";

interface TokenRestrictedRouteProps {
  children: ReactNode;
}

export function TokenRestrictedRoute({ children }: TokenRestrictedRouteProps) {
  const { isRestricted, isLoading } = useTokenRestriction();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    );
  }

  if (isRestricted) {
    return <FeatureInDevelopment />;
  }

  return <>{children}</>;
}
